import React from 'react';
import useStyle from './FormErrorList.style';
import { ClientFormState } from 'types/client/client.def';
import { ErrorText } from 'components/atoms/Texts/ErrorText';
import { clientErrorsFields } from '../../../../helpers/forms/error/clientErrorsFields';

interface FormErrorListProps {
  client: ClientFormState;
}

export const FormErrorList = ({ client }: FormErrorListProps) => {
  const classes = useStyle();
  const errorsTexts = Object.entries(client.errors);

  return (
    <div className={classes.root}>
      <ErrorText
        text={"Certains champs n'ont pas encore été remplis correctement :"}
      />
      <ul>
        {client.errors.methodepaiement !== false && (
          <li>Pas de méthode de paiement selectionné</li>
        )}
        {client.values.affilie && !client.values.relaisid && (
          <li>Pas de point relais selectionné</li>
        )}
        {errorsTexts.length > 0 &&
          errorsTexts
            .filter(error => error[1] !== false)
            .map((error, key) => (
              <li key={key}>
                {error[1] !== 'Ce champ est requis'
                  ? error[1] !== true
                    ? error[1]
                    : 'Ce champ est requis (' +
                      clientErrorsFields[error[0]] +
                      ')'
                  : error[1] + ' (' + clientErrorsFields[error[0]] + ')'}
              </li>
            ))}
      </ul>
    </div>
  );
};
